import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const IndexLogsPage = lazyWithRetry(() => import("./IndexLogsPage"));

export default [
  <Route exact path="/logs/users" key="logs-users" component={IndexLogsPage} />,
];
